module.exports = "npm i hudl-rn-uniform-ui --save --registry=http://npm-pull.hudltools.com/\n"